import { CdkAccordion, CdkAccordionItem } from '@angular/cdk/accordion';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-scheduler-legend',
  imports: [CdkAccordion, CdkAccordionItem, MatIcon, MatTooltip],
  templateUrl: './scheduler-legend.component.html',
  styleUrl: './scheduler-legend.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'select-none',
  },
})
export class SchedulerLegendComponent {
  legendItems = [
    {
      label: 'Mededeling',
      classes: 'event-announcement',
    },
    {
      label: 'Mededeling (herhaald)',
      classes: 'event-announcement recurring',
    },
    {
      label: 'Vraag en antwoord',
      classes: 'event-question-and-answers',
    },
    {
      label: 'Vraag en antwoord (herhaald)',
      classes: 'event-question-and-answers recurring',
    },
    {
      label: 'Vraag en antwoord + pictogrammen',
      classes: 'event-question-and-answers--with-images',
    },
    {
      label: 'Vraag en antwoord + pictogrammen (herhaald)',
      classes: 'event-question-and-answers--with-images recurring',
    },
    {
      label: 'Afbeelding',
      classes: 'event-media-image',
    },
    {
      label: 'Afbeelding (herhaald)',
      classes: 'event-media-image recurring',
    },
    {
      label: 'Audio',
      classes: 'event-media-audio',
    },
    {
      label: 'Audio (herhaald)',
      classes: 'event-media-audio recurring',
    },
  ];
}
